import React from 'react'
import PropTypes from 'prop-types'
import { Typography, Row, Col } from 'antd'
import DetailsWithPhoto from 'components/shared/DetailsWithPhoto'

const { Title } = Typography

export default function Review({ software }) {
  const { name, details, seo_meta: seoMeta, image } = software
  const { title } = seoMeta || {}
  return (
    <Row className="page-wrapper">
      <Title
        className="title-wrapper"
        style={{ width: '100%', marginTop: '32px' }}
      >
        {title || `${name} Review: Features, Pricing`}
      </Title>
      <Col
        xs={24}
        style={{
          fontWeight: 'normal',
          fontSize: '16px',
          lineHeight: '22px',
          marginTop: '32px',
          boxSizing: 'border-box',
        }}
      >
        <DetailsWithPhoto details={details} image={image} />
      </Col>
    </Row>
  )
}

Review.propTypes = {
  software: PropTypes.shape({
    name: PropTypes.string.isRequired,
    details: PropTypes.string.isRequired,
    seo_meta: PropTypes.shape({
      title: PropTypes.string,
    }),
  }).isRequired,
}
